import { Component, Mixins, Watch } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import Folder from '@/folders/entities/folder'

@Component
export default class FolderDialog extends Mixins<EditDialogMixin<Folder>>(
  EditDialogMixin
) {
  @Watch('dialog')
  private async dialogChanged(newValue: boolean) {
    if (newValue) {
      await this.validate()
    }
  }
}
